import React, { useEffect } from 'react'

import { MenuItem, TextField } from '@mui/material'
import { useTypesPriority } from '../../../hooks/useTypesPriority'

interface PriorizationDDLProps {
  onChange:
    | React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
    | undefined
  value: number
  name?: string
  disabled?: boolean
}

export const PriorizationDDL: React.FC<PriorizationDDLProps> = ({
  onChange,
  value,
  name = 'typePriorityId',
  disabled = false
}) => {
  const {
    getTypesPriority,
    typesPriorityState: { typesPriority }
  } = useTypesPriority()

  useEffect(() => {
    if (typesPriority?.length === 0) {
      getTypesPriority()
    }
  }, [])

  return (
    <TextField
      label='Tipo de Prioridad'
      variant='outlined'
      select
      onChange={onChange}
      value={value}
      name={name}
      fullWidth
      disabled={disabled}
    >
      <MenuItem key={0} value={0}>
        Seleccionar prioridad
      </MenuItem>

      {typesPriority &&
        typesPriority.map((option) => (
          <MenuItem key={option.typePriorityId} value={option.typePriorityId}>
            {option.name}
          </MenuItem>
        ))}
    </TextField>
  )
}
